import { useContext, useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import { LoaderContext } from '../../context/LoaderContext';
import './Loader.css';

const LOTTIE_JSON_PATH = '/CricFight_animated.json';

const Loader = () => {
  const { isLoading } = useContext(LoaderContext);
  const containerRef = useRef(null);
  const animRef = useRef(null);

  useEffect(() => {
    if (!isLoading || !containerRef.current) return;

    animRef.current = lottie.loadAnimation({
      container: containerRef.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: LOTTIE_JSON_PATH,
    });

    return () => {
      if (animRef.current) {
        animRef.current.destroy();
        animRef.current = null;
      }
    };
  }, [isLoading]);

  if (!isLoading) {
    return null;
  }

  return (
    <div className="loader-overlay" aria-live="polite" aria-busy="true" data-loader="visible">
      <div className="loader-content">
        <div ref={containerRef} className="loader-lottie" aria-hidden="true" />
      </div>
    </div>
  );
};

export default Loader;
